import { __ } from "@wordpress/i18n";
import React from "react";
import Switch from "../Switch/Switch";
import "./MultiRoleSwitch.scss";
import Hint from "../Hint/Hint";
const MultiRoleSwitch = ({
	settingData,
	rolesArray,
	handleChange,
	baseName = "security.use_admin_password.trusted_roles",
}) => {
	// Ensure rolesArray is always an array
	const safeRolesArray = Array.isArray(rolesArray) ? rolesArray : [];

	// Ensure trusted_roles exists and is an array
	const currentTrustedRoles =
		settingData?.security?.["use_admin_password"]?.["trusted_roles"] || [];

	// Normalize currentTrustedRoles to an array if it's not already
	const trustedRolesArray = Array.isArray(currentTrustedRoles)
		? currentTrustedRoles
		: [currentTrustedRoles].filter(Boolean);

	// Add a check to prevent rendering if no roles
	if (safeRolesArray.length === 0) {
		return null;
	}

	return (
		<div className="multi-role-switch-container">
			{safeRolesArray.map((role) => (
				<div
					key={role.value}
					className={`role-switch-item ${
						role.disabled ? "role-switch-disabled" : ""
					}`}
				>
					<div className="role-switch-content">
						<span className="role-label">
							<Hint
								content={__(
									role.label,
									"ultimate-security",
								)}
							/>
							&nbsp;
							{role.label}
						</span>

						{role.disabled && (
							<div className="role-switch-hint">
								{role.hint || "This is always enabled"}
							</div>
						)}
					</div>

					<Switch
						name={`${baseName}.${role.value}`}
						checked={
							role.disabled ||
							trustedRolesArray.includes(role.value)
								? "1"
								: "0"
						}
						onChange={(name, value) => {
							if (!role.disabled) {
								const newTrustedRoles =
									value === "1"
										? [...trustedRolesArray, role.value]
										: trustedRolesArray.filter(
												(r) => r !== role.value,
										  );

								// Call handleChange with the updated roles array
								handleChange(baseName, newTrustedRoles);
							}
						}}
					/>
				</div>
			))}
		</div>
	);
};

export default MultiRoleSwitch;
